import * as React from 'react';

const Welcome = () => {
  return <div />;
};

export default Welcome;
